import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { useControl } from 'react-map-gl'
import { useRef, useCallback, useEffect, useState } from 'react'

export default function DrawControl({ features, onChange, ...props }) {
  const draw = useRef()
  const [mapReady, setMapReady] = useState(false)
  const [initialFeatureId, setInitialFeatureId] = useState(null)

  const handleMapReady = useCallback(() => {
    setMapReady(true)
  }, [])

  const onDrawChange = useCallback(() => {
    onChange(draw.current.getAll())

    const polygon = draw.current.getAll().features?.[0]
    if (polygon?.id && polygon.id === initialFeatureId) {
      draw.current.changeMode('direct_select', { featureId: polygon.id })
    }
  }, [draw])

  useEffect(() => {
    console.log(features, 'features')
    if (mapReady && features && draw.current) {
      const polygon = features.features?.[0]
      try {
        draw.current.deleteAll()
        draw.current.set(features)

        if (polygon && polygon.id) {
          setInitialFeatureId(polygon.id)
          draw.current.changeMode('direct_select', { featureId: polygon.id })
        }
      } catch (e) {
        console.error(e, features)
      }
    }

    return () => {}
  }, [mapReady, initialFeatureId])

  useControl(() => {
    draw.current = new MapboxDraw(props)
    return draw.current
  }, ({ map }) => {
    setMapReady(map.isStyleLoaded())
    map.on('draw.create', onDrawChange)
    map.on('draw.update', onDrawChange)
    map.on('draw.delete', onDrawChange)
    map.on('load', handleMapReady)
  }, ({ map }) => {
    setMapReady(false)
    map.off('draw.create', onDrawChange)
    map.off('draw.update', onDrawChange)
    map.off('draw.delete', onDrawChange)
    map.off('load', handleMapReady)
  }, {
    position: props.position,
  })

  return null
}
